document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).ready(() => {
    function copyToClipboard(element) {
        var $temp = $("<input>");
        var oldValue = $(element).html();

        $("body").append($temp);
        $temp.val($(element).children("span").html()).select();
        document.execCommand("copy");
        $(element).html("COPIADO");
        setTimeout(function () {
            $(element).html(oldValue);
        }, 1000);
        $temp.remove();
    }

    $("cupom").click(function () {
        copyToClipboard(this);
    });

    // HOVER ON HEADER
    const headers = $(".header-navigation-wrapper");
    headers.mouseover(() => {
        $(document.body).addClass("mouse-on-header");
    });
    headers.mouseout(() => {
        $(document.body).removeClass("mouse-on-header");
    });

    window.upsellSliderInit = function () {
        $(".recommend-slider .swiper-wrapper").slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: true,
            dots: false,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        variableWidth: true,
                        centerMode: false,
                    },
                },
            ],
        });

        $(".recommend-container").addClass("loaded");
    };

    function beforeSend(element) {
        $("#dropdown-cart").addClass("updating-cart");
        $(element).find(".recommend-btn-add").addClass("is-loading");
    }

    function afterSend(element) {
        $("#dropdown-cart").removeClass("updating-cart");
        $(element).find(".recommend-btn-add").removeClass("is-loading");
    }

    $(document).on("submit", ".upsell-form", function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const serializedData = {};
        formData.forEach((value, key) => {
            serializedData[key] = value;
        });
        const jsonData = JSON.stringify(serializedData);

        // URL da API da Shopify para adicionar um item ao carrinho
        const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

        // Opções da requisição
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: jsonData,
        };

        beforeSend(e.target); // Ação "before send" antes da requisição

        // Faz a requisição usando fetch com ação "before send" e "after send"
        fetch(addToCartUrl, requestOptions)
            .then((response) => {
                afterSend(); // Ação "after send" após a conclusão da requisição

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui

                $('.custom-close-button').click();
                Shopify.getCart(window.updateCart);
                $("body").addClass("cart-sidebar-show");
            })
            .catch((error) => {
                // Houve um erro na requisição, você pode tratar o erro aqui
                showWarning('Não foi possível adicionar este produto ao carrinho')
                $('.custom-close-button').click();
            });
    });

    $(document).on("change", ".variants-product-selects select", function () {
        var $currentSelect = $(this);
        var $nextSelect = $currentSelect
            .closest(".variants-product-selects")
            .find("select")
            .eq($currentSelect.index() + 1);

        if (
            $nextSelect.length &&
            $nextSelect.is(":hidden") &&
            $nextSelect.find("option").length > 1
        ) {
            $nextSelect.show();
        } else {
            var selectedOptions = $currentSelect
                .closest(".variants-product-selects")
                .find("select")
                .map(function () {
                    return $(this).val();
                })
                .get();
            var productData = JSON.parse(
                $currentSelect
                    .closest(".variants-product-selects")
                    .find("[data-json-product]")
                    .text()
            );

            var matchingVariant = productData.find(function (variant) {
                return selectedOptions.every(function (option, index) {
                    return variant.options[index] === option;
                });
            });

            if (matchingVariant && matchingVariant.available) {
                $currentSelect
                    .closest(".variants-product-selects")
                    .find(".variantIdAddCart")
                    .val(matchingVariant.id);
                $currentSelect
                    .closest(".variants-product-selects")
                    .find(".recommend-btn-add")
                    .prop("disabled", false);
                $currentSelect
                    .closest(".variants-product-selects")
                    .find(".recommend-btn-add")
                    .val("ADICIONAR");
            } else {
                $currentSelect
                    .closest(".variants-product-selects")
                    .find(".recommend-btn-add")
                    .prop("disabled", true);
                $currentSelect
                    .closest(".variants-product-selects")
                    .find(".recommend-btn-add")
                    .val("ESGOTADO");
            }
        }

        var container = $(".halo-cart-sidebar").find(".previewCart");
        var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

        // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
        var scrollPosition =
            scrollTo.offset().top +
            scrollTo.outerHeight() +
            container.scrollTop() -
            container.position().top;

        // Realiza a rolagem
        container.animate(
            {
                scrollTop: scrollPosition,
            },
            1000
        ); // 1000 milissegundos para a animação de rolagem
    });
    
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a[href*='/collections/']").forEach(link => {
        let url = new URL(link.href, window.location.origin);
        let params = url.searchParams;

        if (!params.has('filter.v.availability') || params.get('filter.v.availability') !== '1') {
            params.set('filter.v.availability', '1'); // Adiciona ou substitui o parâmetro
            link.href = url.toString(); // Atualiza o link
        }
    });
});

// Seletor de tamanho: nenhuma opção aparece destacada até o cliente escolher
document.addEventListener("change", function (event) {
    var input = event.target;
    if (
        input &&
        input.classList &&
        input.classList.contains("product-form__radio") &&
        input.closest(".variant-picker--size")
    ) {
        document.body.classList.add("has-size-selection");
    }
});

/* ------------------------------------------------------------------
   Botao flutuante de compra (mobile) na pagina de produto
   - com tamanho escolhido: adiciona ao carrinho e abre o carrinho
   - tamanho indisponivel: botao inativo com o texto do botao real
   - sem escolha: painel abre sem marcacao e avisa ao tentar comprar
   ------------------------------------------------------------------ */
(function () {
    var SIZE_LABEL_SELECTOR =
        ".variant-picker--size .product-form__label, .variant-picker--size .product-form__radio, " +
        ".variant-picker--size-mobile .product-form__label, .variant-picker--size-mobile .product-form__radio";
    var WARNING_TIMEOUT = 1300;

    var shortcutOriginalText = null;
    var panelVariants = null;
    var warningTimer = null;

    function hasSizePicker() {
        return document.querySelector(".variant-picker--size") !== null;
    }

    function hasActiveSelection() {
        return document.body.classList.contains("has-size-selection");
    }

    function getShortcutButton() {
        return document.getElementById("show-sticky-product");
    }

    function getRealAddButton() {
        return document.getElementById("product-sticky-add-to-cart");
    }

    function getVariantInput() {
        var realButton = getRealAddButton();
        var form = realButton && realButton.closest ? realButton.closest("form") : null;
        return form ? form.querySelector('input[name="id"]') : null;
    }

    /* 1) Escolha ativa tambem no clique: tocar no tamanho ja pre-marcado
       pela Shopify nao dispara "change" e ficaria sem registro. */
    document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest(SIZE_LABEL_SELECTOR)) return;

        document.body.classList.add("has-size-selection");
        window.setTimeout(function () {
            syncShortcutButton();
            syncPanelWithCurrentVariant();
        }, 50);
    });

    /* 2) Atalho espelha disponibilidade do botao de compra real */
    function syncShortcutButton() {
        var shortcut = getShortcutButton();
        var realButton = getRealAddButton();
        if (!shortcut || !realButton) return;

        if (shortcutOriginalText === null) {
            shortcutOriginalText = shortcut.textContent.trim();
        }

        if (!hasActiveSelection()) return;

        if (realButton.hasAttribute("disabled")) {
            shortcut.setAttribute("disabled", "disabled");
            shortcut.textContent = realButton.textContent.trim();
        } else {
            shortcut.removeAttribute("disabled");
            shortcut.textContent = shortcutOriginalText;
        }
    }

    function observeRealButton() {
        var realButton = getRealAddButton();
        if (!realButton || typeof window.MutationObserver !== "function") return;

        new window.MutationObserver(function () {
            syncShortcutButton();
        }).observe(realButton, {
            attributes: true,
            attributeFilter: ["disabled"],
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    /* 3) Clique no atalho com tamanho ja escolhido: compra direto */
    document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest("#show-sticky-product")) return;
        if (!hasSizePicker()) return;
        if (!hasActiveSelection()) return;

        var realButton = getRealAddButton();
        if (!realButton || realButton.hasAttribute("disabled")) return;

        var variantInput = getVariantInput();
        if (!variantInput || !variantInput.value) return;

        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove("show-mobile-options");
        realButton.click();
    }, true);

    /* 4) Painel reflete a variante corrente quando ha escolha ativa.
       Marcacao sem disparar "change" para nao reentrar no componente. */
    function getPanelVariants(panel) {
        if (panelVariants) return panelVariants;

        var script = panel.querySelector('script[type="application/json"]');
        if (!script) return null;

        try {
            panelVariants = JSON.parse(script.textContent);
        } catch (error) {
            return null;
        }
        return panelVariants;
    }

    function syncPanelWithCurrentVariant() {
        var panel = document.querySelector(".sticky-product-mobile");
        if (!panel || !hasActiveSelection()) return;

        var variantInput = getVariantInput();
        if (!variantInput || !variantInput.value) return;

        var variants = getPanelVariants(panel);
        if (!variants || !variants.length) return;

        var current = null;
        variants.forEach(function (variant) {
            if (String(variant.id) === String(variantInput.value)) current = variant;
        });
        if (!current || !current.options) return;

        panel.querySelectorAll("fieldset[data-option-index]").forEach(function (fieldset) {
            var index = parseInt(fieldset.getAttribute("data-option-index"), 10);
            var value = current.options[index];
            if (isNaN(index) || value === undefined || value === null) return;

            fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
                if (radio.value === value && !radio.checked) radio.checked = true;
            });
        });
    }

    /* 5) Sem escolha de tamanho: bloqueia a compra e avisa no painel */
    function showPanelWarning() {
        var warning = document.querySelector(".sticky-product-mobile .aviso-selecao");
        if (!warning) return;

        warning.classList.add("active-erro");
        window.clearTimeout(warningTimer);
        warningTimer = window.setTimeout(function () {
            warning.classList.remove("active-erro");
        }, WARNING_TIMEOUT);
    }

    document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest("#product-sticky-add-to-cart")) return;
        if (!hasSizePicker()) return;
        if (!document.body.classList.contains("show-mobile-options")) return;
        if (hasActiveSelection()) return;

        event.preventDefault();
        event.stopPropagation();
        showPanelWarning();
    }, true);

    function init() {
        if (!getShortcutButton()) return;
        syncShortcutButton();
        observeRealButton();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();